// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2a2q4","ranges":"BmiRanges_ranges__b8LfV"};